module.exports = require('./convert')(
  ".exports=func\"#$%&'()*+,-/0123456789:;<>@[]^_`abdghijklmqvwyz{}~",
  "юучзщкеыһагтсЭІҢҒ:эҰҚҮҺбө№қ\"әіңғ,.үұЖжБЮӘхъ;Ө(фивпршолдьймцняХЪ)"
)
